import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Info Slab Circle Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-info-slab-circle-outline',
    templateUrl: './icon-info-slab-circle-outline.component.html',
    styleUrls: ['./icon-info-slab-circle-outline.component.scss'],
    standalone: false
})
export class IconInfoSlabCircleOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
